import styled from "@emotion/styled";

type Props = {
  ifEmptyAddress?: boolean;
};

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 60%;
  padding-top: 20px;
`;

export const ConfirmButton = styled.button<Props>`
  width: 80px;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  padding: 10px;
  border: none;
  border-radius: 30px;
  ${({ ifEmptyAddress }) =>
    ifEmptyAddress
      ? `background: #aaa;`
      : `background: #1f8feb; cursor: pointer;`};
`;
